import src from "IMAGE";
export default { src, width: 319, height: 244, blurWidth: 0, blurHeight: 0};
